<template>
    <div class="flex flex-col h-0 grow">
        <grid-card
            v-if="meta.length > 0"
            :columns-meta="meta"
            :data="listStore"
            :totalCountProps="totalCountRef"
            :toolbar="toolbar"
            :is-grouping="false"
            :masterDetailComponent="masterDetailComponent"
            ref="gridInstance"
            @expandParentItem="expandParentItem"
            @getHiddenColumns="getHiddenColumns"
            @onFocusedRowChanging="onFocusedRowChanging"
            @on-context-menu="onContextMenu"
            @selectionChanged="selectionChanged"
            @onRowExpanding="onRowExpanding"
        >
        </grid-card>
    </div>
</template>

<script>
export default {
    name: 'temp_view-kv-customer-vers',
};
</script>

<script setup>
import gridCard from '@/components/grid-card-component/grid-card.vue';
import viewKvCustomerVersChildren from './temp_view-kv-customer-vers-children.vue';
import store from '@/store';
import { computed, reactive, ref, toRaw } from 'vue';
// import { getKvCustomerVersParentsStoreAsp } from '@/service/counteragent-service';
import { useRouter } from 'vue-router';

const router = useRouter();
const recentlySelectedDataGrid = ref(null);
const selectedParents = ref([]);
const hiddenColumns = ref([]);

// const totalCountRef = computed(() => {
//     return listStore.getDataSource ? listStore.getDataSource().totalCount() : 0;
// });

// const listStore = getKvCustomerVersParentsStoreAsp();
const loadMeta = async () => {
    await store.dispatch('loadCustomerVersMetaData', { name: 'view-kv-customer-vers' });
};

loadMeta();

const childMeta = computed(() => {
    const metaWithHiddenColumns = store.state.counteragentVersGrid.gridMeta.map(el => {
        if (!hiddenColumns.value.includes(el.field)) {
            return {
                ...el,
                visible: el.visible,
            };
        } else {
            return {
                ...el,
                visible: false,
            };
        }
    });
    const data = metaWithHiddenColumns;
    return toRaw(data);
});

const onFocusedRowChanging = e => {
    if (recentlySelectedDataGrid.value && recentlySelectedDataGrid.value !== e.component) {
        recentlySelectedDataGrid.value.option('focusedRowIndex', -1);
    }
    recentlySelectedDataGrid.value = e.component;
};

const onRowExpanding = e => {
    console.log(e);
};
const selectionChanged = e => {
    selectedParents.value = e.selectedRowKeys;
};
const onContextMenu = event => {
    event.component.collapseAll(-1);
    if (event.target !== 'content') return;
    event.items = [
        {
            text: 'Посмотреть карточку контрагента',
            onItemClick(e) {
                console.log('item', e);
                const id = event.row.data.id;
                router.push({
                    name: 'VersionCounteragentCardView',
                    params: { id },
                });
            },
        },
    ];
};
const masterDetailComponent = reactive({
    component: viewKvCustomerVersChildren,
    enabled: true,
    props: {
        columnsMeta: childMeta,
        onFocusedRowChanging: onFocusedRowChanging,
        onContextMenu: onContextMenu,
        selectedParents: selectedParents,
    },
});

const toolbar = {
    items: [
        'searchPanel',
        'groupPanel',
        {
            widget: 'dxButton',
            location: 'before',
            options: {
                hint: 'Обновить',
                icon: 'refresh',
                onClick: () => {
                    gridInstance.value.gridInstance.refresh();
                },
            },
        },
        {
            widget: 'dxDropDownButton',
            location: 'before',
            options: {
                icon: 'export',
                dropDownOptions: { width: 400 },
                items: [
                    {
                        icon: 'importselected',
                        text: 'Экспортировать выбранные строки в EXCEL',
                        onClick: () => {
                            console.log('export');
                        },
                    },
                    {
                        icon: 'importselected',
                        text: 'Экспортировать выбранные строки в PDF',
                        onClick: () => {
                            console.log('export');
                        },
                    },
                    {
                        icon: 'importselected',
                        text: 'Экспортировать выбранные строки в WORD',
                        onClick: () => {
                            console.log('export');
                        },
                    },
                ],
            },
        },
        {
            visible: false,
            location: 'before',
            name: 'columnChooserButton',
        },
        {
            location: 'before',
            widget: 'dxMenu',
            class: 'settings',
            iconAlignment: 'top',
            options: {
                items: [
                    {
                        icon: 'preferences',
                        items: [
                            {
                                text: 'Скрытые колонки',
                                onClick: () => {
                                    gridInstance.value.gridInstance.showColumnChooser();
                                },
                            },
                            {
                                text: 'Сбросить настройки',
                                onClick: async () => {
                                    gridInstance.value.refreshMeta();
                                },
                            },
                        ],
                        alignment: 'center',
                    },
                ],
            },
        },
    ],
};

const getHiddenColumns = () => {
    const dataFieldsVisible = gridInstance.value.gridInstance.getVisibleColumns().map(el => el.dataField);

    const resulted = gridInstance.value.gridInstance
        .option('columns')
        .filter(el => dataFieldsVisible.indexOf(el.dataField) < 0)
        .map(el => el.dataField);

    hiddenColumns.value = resulted;
};

const gridInstance = ref(null);

const meta = computed(() => {
    const data = store.state.counteragentVersGrid.gridMeta;
    return toRaw(data);
});
</script>

<style scoped>
:deep(.dx-master-detail-cell) {
    background-color: rgba(255, 86, 34, 0.081) !important;
}
</style>
